import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
// import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import MenuforWeb from '../Menu/MenuforWeb';
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export default function NavBar() {

  const [bgColor, setBgColor] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate("");

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setBgColor(true);
    } else {
      setBgColor(false);
    }
  };


  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  return (



    <div className={` absolute w-full `} >


      <div className={`${bgColor ? "bg-black" : "bg-transparent"} z-50 transition-colors duration-200   fixed w-full`}>

        <nav className='flex z-20 justify-around text-white bg-black bg-opacity-35 py-4 items-center '>

          <h2 className='text-3xl z-30 text-white uppercase font-bold bg-transparent'> South Global EXIM</h2>

          <p className="md:hidden block"> <MenuforWeb /> </p>
          <ul className='md:flex gap-5  text-lg bg-transparent z-50  hidden'  >


            <Link to={"/"} className='bg-transparent'>Home</Link>
            <Link to={"/about"} className='bg-transparent'>About</Link>
            <Link to={"/products"} className='bg-transparent'>Products</Link>
            <Link to={"/quickQuotation"} className='bg-transparent'>Quick Quotation</Link>



          </ul>

          <button className='border hidden rounded-xl py-2 px-4 bg-transparent md:block text-lg hover:bg-green-500 transition-colors duration-200' onClick={() => navigate("/contact")}>Contact us </button>
          {/* <div onClick={handleSetIsOpen} className=' md:hidden  bg-transparent'>
          < MenuforWeb isOpen={isOpen} />
              </div> */}
      
        </nav>

      </div>

    </div>
  )
}